import React, { useEffect, useState } from 'react'
import styled from "styled-components";
import Spinner from '@/components/Spinner'

import { ethers } from "ethers";
import Info from "@/components/NftInfo/Modal";
import { useContractRead, useAccount, useContractReads } from 'wagmi'
import { redirect } from 'react-router'
import { useWarrior } from '@/hooks/useWarrior'
import { useProvider } from 'wagmi'
import classnames from "classnames";
import {usePrevent} from "../hooks/usePrevent";

export default function MySquad() {

  const [isOpen, setIsOpen] = useState(false);
  const [curObj, setObj] = useState({});
  const { warriors, loading } = useWarrior()
  const provider = useProvider()

  usePrevent()

  const handleClick = (item)=>{
    setObj(item)
    setIsOpen(true)
  }

  
  return (
   <>
     <Wrapper>
        <div className='main-title'>My Warriors</div>
        <Spinner loading={loading}>
          <div className='col'>
             {
               !loading && (warriors.length ?
               <div className='list-nfts'>

                 {warriors.map(item => {
                   return <div className={classnames('card', {'nft-genie': item.type === 7})} key={item.tokenId}
                               onClick={() => handleClick(item)}
                   >
                     <div className="card-title">{item.info.name}</div>
                     <img src={item.info.poster}  className="card-image" />
                     <div className="card-id">#{item.tokenId}</div>
                   </div>
                 })}

               </div> : 'no warriors')
             }
          </div>
       </Spinner>
    </Wrapper>
      
    <Info isOpen={isOpen} handleClose={() => setIsOpen(false)} item={curObj}/>
   </>
  )
}

const Wrapper = styled.div`
  padding-left: 61px;
  min-width: 1280px;
  padding-top: 40px;
  
  .col{
    display: flex;
  }
  
  .main-title{
    font-weight: 600;
    font-size: 55px;
    line-height: 76px;
    color: #32DE86;
    padding-bottom: 20px;
  }
  
  .card {
    width: 240px;
    height: 388px;
    background: #161616;
    border-radius: 20px;
    padding: 20px;
    box-sizing: border-box;
    transition: 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    margin: 0 0 30px 30px;
    
    img {
      width: 200px;
      height: 200px;
      border-radius: 20px;
      display: block;
      margin: 15px 0 40px;
    }
    
    &:hover{
      transform-origin: center;
      transform: scale(1.08, 1.08);
      cursor: pointer;
      .cursor-svg{
        display: block;
      }
    }
  }
  
  .card-title {
    display: block;
    text-align: center;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;

    background: linear-gradient(96.65deg, #7AFF35 9.48%, #51EAFF 30.22%, #FF58C6 52.85%, #8459FF 95.21%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    text-shadow: 0px 0px 38.5416px #FFFFFF;
  }

  .card-id {
    display: block;
    text-align: center;
    height: 35px;
    line-height: 35px;
    background: linear-gradient(96.65deg, #D5FFBF 9.48%, #8EECF9 40.71%, #FFADFD 70.77%, #9A7EF5 95.21%);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    font-size: 16px;
    color: #000000;
  }
  
  
  .nft-genie {
    .card-title {
      background-image: linear-gradient(95.27deg, #F6442D 9.01%, #FFFDC5 35.94%, #00A4FF 64.12%, #00D9A2 89.8%);
    }
    .card-id {
      background: linear-gradient(96.65deg, #FF7F72 9.48%, #EBE9B6 39.65%, #6DBBE6 73.13%, #78FFDD 100%);
    }
  }
  
  .list-nfts{
    display: flex;
    flex-wrap: wrap;    
    padding-right: 80px;
  }
`;
